import { Add } from "@mui/icons-material";
import { Box, InputBase, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { addPatientExternalReferralsServicesCallHistory } from "../../api/group";
import { CheckBoxBranch } from "../../components/signin/chekboxListBranch";

export default function CallHistories({
  areaId,
  patientId,
  dataService,
  formId,
}) {
  const [dataAll, setDataAll] = useState([
    {
      description: "",
      answered: true,
      counter: 1,
    },
  ]);

  const handleInputChange = (index, value) => {
    setDataAll(
      dataAll?.map((row, i) =>
        i === index ? { ...row, description: value } : row
      )
    );
  };
  const handleCheckboxChange = (index, checked) => {
    setDataAll(
      dataAll.map((row, i) =>
        i === index ? { ...row, answered: checked } : row
      )
    );
  };
  useEffect(() => {
    if (dataService?.callHistories) {
      if(dataService?.callHistories?.length>0){
        setDataAll(dataService?.callHistories)
      }
    }
  }, [dataService]);
  return (
    <>
      <Box bgcolor="#EFF1F7" p="10px">
        <Typography color="#126E83" p="20px 10px" fontWeight={"bold"}>
          {"تماس"}
        </Typography>
        <Box display={"flex"} justifyContent="space-between">
          <Box>
            <Typography width="100px" color="#636971" textAlign={"center"}>
              {"اطلاعات"}
            </Typography>
          </Box>
          <Box display="flex">
            <Typography width="120px" color="#636971" textAlign={"center"}>
              {"جواب داد"}
            </Typography>
            <Typography width="120px" color="#636971" textAlign={"center"}>
              {"جواب نداد"}
            </Typography>
            <Typography width="200px" color="#636971" textAlign={"center"}>
              {"توضیحات"}
            </Typography>
          </Box>
        </Box>
        {dataAll?.map((x, i) => (
          <Box pt="20px" display={"flex"} justifyContent="space-between">
            <Box>
              <Typography width="100px" textAlign={"center"}>
                {`تماس ${i + 1}`}
              </Typography>
            </Box>
            <Box display="flex">
              <Box
                width="120px"
                mt="-15px"
                display="flex"
                justifyContent={"center"}
              >
                <CheckBoxBranch
                  onChange={(e) => handleCheckboxChange(i, true)}
                  width={"40px"}
                  checked={x.answered}
                />
              </Box>
              <Box
                width="120px"
                mt="-15px"
                display="flex"
                justifyContent={"center"}
              >
                <CheckBoxBranch
                  onChange={(e) => handleCheckboxChange(i, false)}
                  width={"50px"}
                  checked={!x.answered}
                />
              </Box>
              <Box width="200px" color="#636971" textAlign={"center"}>
                <InputBase
                  sx={{
                    height: "40px",
                    bgcolor: "white",
                    border: "solid 1px #636971",
                    px: "5px",
                    borderRadius: "6px",
                    mt: "-5px",
                  }}
                  value={x.description}
                  onChange={(e) => handleInputChange(i, e.target.value)}
                />
              </Box>
            </Box>
          </Box>
        ))}
        <Box
          borderTop={"1px solid #c7c5c5"}
          py="10px"
          sx={{ cursor: "pointer" }}
          borderBottom={"1px solid #c7c5c5"}
          px="30px"
          display="flex"
          gap="10px"
          alignItems={"center"}
          onClick={() => {
            const lastRow = dataAll[dataAll.length - 1];
            if (lastRow.description.trim() === "") {
              toast.error("لطفاً ابتدا مقدار سطر قبلی را وارد کنید!");
              return;
            }
            addPatientExternalReferralsServicesCallHistory(
              areaId,
              patientId,
              formId,
              dataService?.id,
              lastRow
            )
              .then(() => {
                setDataAll([
                  ...dataAll,
                  {
                    description: "",
                    answered: true,
                    counter: dataAll?.length + 1,
                  },
                ]);
              })
              .catch(() => {});
          }}
        >
          <Add sx={{ transform: "scale(1.2)", color: "var(--emr-darkblue)" }} />
          <Typography mt="2px" color="var(--emr-darkblue)">
            {"افزودن سطر جدید"}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
